module.exports = __webpack_public_path__ + "img/site.bc38a2e5.svg";